<template>
  <div>
    <div class="my-6">
      <h3 class="font-bold">List of {{ route.name }}</h3>
      <span class="text-sm text-gray-500"
        >Here you can observe all items related to the category.
      </span>
    </div>
    <div class="flex mb-6 justify-end">
      <router-link to="/categories/create">
        <Button
          color="primary"
          :text="`Create new category`"
        />
      </router-link>
    </div>
    <div class="card">
      <DataTable
        :headers="headers"
        :data="data"
        :options="options"
        color="primary"
      />
    </div>
  </div>
</template>

<script>
import DataTable from "../../components/Elements/Datatable.vue";
import Button from "../../components/Elements/Button.vue";
import { inject, onMounted, ref } from "vue";
import { GET, DELETE, PATCH } from "../../services/api";
import { useRoute, useRouter } from "vue-router";

export default {
  name: "categories",
  components: {
    DataTable,
    Button,
  },
  setup() {
    const headers = [
      { key: "Id", value: "id" },
      { key: "Name", value: "name" },
      { key: "Status", value: "active" },
      { key: "Options", value: "" },
    ];

    const route = useRoute();
    const router = useRouter();
    const modal = inject("modal");
    const alert = inject("alert");
    const loader = inject("loading");
    const data = ref([]);

    onMounted(async () => {
      try {
        loader.open();
        const categories = await GET("categories");
        data.value = categories.map(el => {
          const schema = {
            ...el,
            active: el.deleted_at == null ? 'active' : 'desactive'
          }
          return schema
        }).sort((a, b) => a.id < b.id ? -1 : (a.id > b.id ? 1 : 0))
        loader.close();
      } catch (e) {
        loader.close();
        if (
          e.includes("Token") ||
          e.includes("t_dynamik") ||
          e == "Unauthorized"
        ) {
          localStorage.removeItem("t_dynamik");
          localStorage.removeItem("info_dynamik");
          router.push({ path: "/login" });
        }
        alert.open("Error", e, "danger");
      }
    });

    const deleteItem = (project) => {
      loader.open();
      const deleteFunction = async function () {
        try {
          loader.open();
          await DELETE(`categories/${project.id}`);
          data.value = data.value.filter((item) => item.id != project.id);
          loader.close();
          alert.open(
            "Success!",
            `Category was deleted successfully!`,
            "success"
          );
        } catch (e) {
          loader.close();
          if (
            e.includes("Token") ||
            e.includes("t_dynamik") ||
            e == "Unauthorized"
          ) {
            localStorage.removeItem("t_dynamik");
            localStorage.removeItem("info_dynamik");
            router.push({ path: "/login" });
          }
          alert.open("Error", e, "danger");
        }
      };
      modal.open(
        "Attention",
        "Do you really wish to delete this category?",
        "warning",
        "Yes",
        () => deleteFunction(),
        modal.close()
      );
      loader.close();
    };

    const changeStatus = (category) => {
      try {
        const statusFunction = async function () {
          try {
            loader.open();
            await PATCH(`categories/${category.id}`, { deleted_at: category.deleted_at ? null : new Date().toISOString() });
            const categories = await GET("categories");
            data.value = categories.map(el => {
              const schema = {
                ...el,
                active: el.deleted_at == null ? 'active' : 'desactive'
              }
              return schema
            }).sort((a, b) => a.id < b.id ? -1 : (a.id > b.id ? 1 : 0))
            loader.close();
            alert.open("Success!", `Category was update successfully!`, "success");
          } catch (e) {
            loader.close();
            if (
              e.includes("Token") ||
              e.includes("t_dynamik") ||
              e == "Unauthorized"
            ) {
              localStorage.removeItem("t_dynamik");
              localStorage.removeItem("info_dynamik");
              router.push({ path: "/login" });
            }
            alert.open("Error", e, "danger");
          }
        }
        loader.open();
        modal.open(
          "Attention",
          "Do you really wish to change this category status?",
          "warning",
          "Yes",
          () => statusFunction(),
          modal.close()
        );
        loader.close();
      } catch (error) {
        loader.close();
      }
    }

    const options = [
      { icon: "block", action: (param) => changeStatus(param), title: "Change status", use:'active' },
      { icon: "pen", path: "/categories/edit", title: "Edit category" },
      {
        icon: "trash",
        action: (param) => deleteItem(param),
        title: "Delete category",
      },
    ];

    return { headers, data, options, route };
  },
};
</script>

<style>
</style>